import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, TabSyncService } from '@pulpo/pulpo-api';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'pulpo-admin';

  private tabSyncUnsub?: () => void;

  constructor(
    private router: Router,
    private authService: AuthService,
    private tabSyncService: TabSyncService
  ) {}

  ngOnInit() {
    this.tabSyncUnsub = this.tabSyncService.listen(
      () => {
        this.authService.logoutLocal();
        this.router.navigate(['/login']);
      },
      (_at, _rt) => {
        // Token mis à jour dans localStorage par l'autre onglet — rien à faire
      }
    );
  }

  ngOnDestroy() {
    this.tabSyncUnsub?.();
  }
}
